import axios from 'axios';
import api, { API_BASE_URL } from './client';
import type { LoginResponse, LoginCredentials, RegisterCredentials, User } from './types';

export async function register(credentials: RegisterCredentials): Promise<User> {
  try {
    const { data } = await api.post<User>('users/register/', credentials);
    return data;
  } catch (error: any) {
    console.error('❌ Register error:', error);
    throw error;
  }
}

export async function login(credentials: LoginCredentials): Promise<LoginResponse> {
  console.log('🔐 Login attempt:', { email: credentials.email, password: '***' });
  console.log('🌐 API URL:', import.meta.env.VITE_API_URL);
  
  try {
    const { data } = await api.post<LoginResponse>('users/login/', credentials);
    console.log('✅ Login successful:', data);
    localStorage.setItem('access', data.tokens.access);
    localStorage.setItem('refresh', data.tokens.refresh);
    localStorage.setItem('user', JSON.stringify(data.user));
    return data;
  } catch (error: any) {
    console.error('❌ Login error:', error);
    console.error('❌ Error response:', error.response?.data);
    throw error;
  }
}

export async function logout(): Promise<void> {
  const refresh = localStorage.getItem('refresh');
  const access = localStorage.getItem('access');
  try {
    if (refresh) {
      // Instance NUE, sans intercepteur : sur l'instance `api`, un jeton déjà
      // expiré déclenchait une tentative de rafraîchissement au beau milieu de
      // la déconnexion. Délai court : se déconnecter ne doit jamais faire
      // patienter, même serveur injoignable.
      await axios.post(
        `${API_BASE_URL}users/logout/`,
        { refresh },
        {
          headers: {
            'Content-Type': 'application/json',
            ...(access ? { Authorization: `Bearer ${access}` } : {}),
          },
          timeout: 5000,
        },
      );
    }
  } catch {
    // Révocation côté serveur impossible (jeton expiré, réseau) : la
    // déconnexion locale reste effectuée, c'est ce que l'utilisateur demande.
  } finally {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user');
  }
}

export async function getProfile(): Promise<User> {
  const { data } = await api.get<User>('users/profile/');
  localStorage.setItem('user', JSON.stringify(data));
  return data;
}

export function getCurrentUser(): User | null {
  try {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  return Boolean(localStorage.getItem('access'));
}
